import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import Tiles from 'app/components/tile/Tiles';
import Tile from 'app/components/tile/Tile';
import {Subheading} from 'app/styles/heading';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {fetchLeagueRankings} from 'app/routes/league/LeaguePageActions';
import {LeagueRankingsPageReducer} from 'app/routes/league/LeaguePageReducer';
import {CompetitionRankingsContent} from 'app/components/competitions/CompetitionRankings';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const LeagueRankingsPage = ({defaultTitle, districtName, baseUrl, dispatchRedux}) => {
  const {restoredData} = useRestoreData('LeagueRankingsPage');
  const {leagueSlug, seasonSlug} = useParams();
  const initialState = restoredData ?? {
    isFetching: false,
    data: {},
  };
  const [state, dispatch] = useReducer(LeagueRankingsPageReducer, initialState);

  const loadData = () => fetchLeagueRankings(leagueSlug, seasonSlug, dispatchRedux)(dispatch, state);
  const {data, isFetching} = state;
  useFetchData(state, loadData, 'LeagueRankingsPage');

  const meta = [
    {
      name: 'description',
      content: `Die wichtigsten Fakten und Statistiken der Liga ${defaultTitle} - Kreis ${districtName}.`,
    },
  ];

  return (
    <ContentAdDesktop superbannerOnly top='7.125rem'>
      <Helmet title='Rankings - ' meta={meta} />
      <Subheading variant='subheading2'>Liga-Rankings</Subheading>
      <Tiles>
        <Tile label='Torjäger' type='1' icon='football' link={`${baseUrl}/scorers`} />
        <Tile label='Zuschauer' type='2' icon='group' link={`${baseUrl}/spectators`} />
        <Tile label='Ewige Tabelle' type='3' icon='star' link={`/league/${leagueSlug}/standing/alltime`} />
      </Tiles>
      <Subheading variant='subheading2'>Top-Facts</Subheading>
      <CompetitionRankingsContent stats={data} isFetching={isFetching} />
    </ContentAdDesktop>
  );
};

LeagueRankingsPage.propTypes = {
  defaultTitle: string.isRequired,
  districtName: string.isRequired,
};

export default LeagueRankingsPage;
